import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import QuoteFormContact from "./sections/QuoteFormContact";
import RemodelPrinciples from "./sections/RemodelPrinciples";
import Impact from "./sections/Impact";
import Testimonials from "./sections/Testimonials";
import Faq from "./sections/Faq";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
import RemodelServices from "./sections/RemodelServices";
export default function HomePage() {
  return <div>
      <Navigation />
      
      <QuoteFormContact />
      <RemodelServices />
      <RemodelPrinciples />
      <Impact />
      
      <Faq />
      <Quote />
      <Footer />
    </div>;
}